import { IonHeader, IonModal, IonContent, IonGrid, IonRow, IonCol } from '@ionic/react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IImageSliderModalProps } from './image-slider-modal-props.interface'
import './image-slider-modal.scss'
import { BaseButton, ImageSlider } from 'components'
import { icon_close } from 'icons'

const ImageSliderModal: React.FC<IImageSliderModalProps> = ({ items, isOpen, setIsOpen }) => {
  const [activeSlide, setActiveSlide] = useState(1)

  const { t } = useTranslation()

  return (
    <IonModal isOpen={isOpen} className="edisu-image-slider-modal">
      <IonHeader className="modal-header">
        <IonGrid>
          <IonRow className="ion-align-items-center">
            <IonCol size="3" className="ion-justify-content-start">
              <BaseButton color="terziary" fill="clear" icon={icon_close} onClickFunction={() => setIsOpen(false)} label={t('close')} />
            </IonCol>
            <IonCol size="6" className="ion-text-center">
              <span className="edisu-text-normal">
                {activeSlide}/{items.length}
              </span>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonHeader>
      <IonContent className="modal-content">
        <ImageSlider showAll={false} items={items} setActiveIndex={setActiveSlide} innerNavigation={false} />
      </IonContent>
    </IonModal>
  )
}

export default ImageSliderModal
